import React, { FC, ReactNode, MouseEvent } from 'react'
import Icon from 'components/base-ui/Icon'
import { Wrapper, Content } from './styled'

interface ItemProps {
  testId?: string
  id?: string
  children: ReactNode
  mainIcon?: string
  rightIcon?: string
  highlight?: boolean
  border?: boolean
  singleBorder?: boolean
  iconSize?: string
  iconAlignTop?: boolean
  rightIconSize?: string
  disabled?: boolean
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void
}

const Item: FC<ItemProps> = ({
  testId,
  id,
  children,
  mainIcon,
  highlight = false,
  rightIcon,
  border = false,
  singleBorder = false,
  iconSize = '20px',
  rightIconSize = '10px',
  iconAlignTop = false,
  disabled = false,
  onClick,
}) => {
  return (
    <Wrapper
      data-testid={testId}
      id={id}
      onClick={onClick}
      singleBorder={singleBorder}
      highlight={highlight}
      border={border}
      iconAlignTop={iconAlignTop}
      disabled={disabled}
    >
      {mainIcon && <Icon name={mainIcon} size={iconSize} />}
      <Content>{children}</Content>
      {rightIcon && <Icon name={rightIcon} size={rightIconSize} />}
    </Wrapper>
  )
}

export default Item
